import { createSlice } from "@reduxjs/toolkit";
import ImageExample from "../../assets/Anh1.jpg";
const fakeData = [
  {
    id: "1",
    title:
      "Câu lạc bộ doanh nhân đồng hương Bạc Liêu, Cà Mau tại TP Cần Thơ vận động trên 3,3 tỉ đồng thực hiện nhiều hoạt động từ thiện xã hội",
    description:
      "Chiều 28-7, Câu lạc bộ doanh nhân đồng hương Bạc Liêu, Cà Mau tại TP Cần Thơ (CLB BCCCT) tổ chức họp mặt kỷ niệm 1 năm thành lập. Ông Quảng Tấn Hiếu, Phó Chủ tịch thường trực UBND TP Cần Thơ và bà Lâm Kim Khôi, Chủ tịch CLB BCCCT trao quyết định kiện toàn Ban chấp hành CLB",
    image: ImageExample,
    isLarge: true,
  },
  {
    id: "2",
    title:
      "Câu lạc bộ doanh nhân đồng hương Bạc Liêu, Cà Mau tại TP Cần Thơ vận động trên 3,3 tỉ đồng thực hiện nhiều hoạt động từ thiện xã hội",
    description: "Chiều 28-7, Câu lạc bộ doanh nhân đồng hương Bạc Liêu, Cà",
    image: ImageExample,
    date: "28/7",
  },
  {
    id: "3",
    title:
      "LẦN ĐẦU TIÊN TỔ CHỨC MỪNG THỌ CHO CÁC CỤ ĐỒNG HƯƠNG TỪ 80 TUỔI TRỞ LÊN",
    description:
      "Ngày 27/01/2024, tại khách sạn Ninh Kiều Riverside, lần đầu tiến tổ",
    image: ImageExample,
    date: "27/01/2024",
  },
  {
    id: "4",
    title:
      "Hội đồng hương Bạc Liêu – Cà Mau huy động trên 5,5 tỷ đồng hướng về quê hương",
    description: "Ngày 27/1, tại TP Cần Thơ diễn ra Chương trình họp mặt đồng",
    image: ImageExample,
    date: "27/1",
  },
  {
    id: "5",
    title: "NGÀY 22/8/2023, BCCU ĐẾN THĂM TỔNG CTY CP THỦY SẢN TÂM PHƯƠNG NAM",
    description: "Tiếp đoàn BCCU là doanh nhân Huỳnh Thanh Tâm, quê Cà Mau.",
    image: ImageExample,
    date: "22/8/2023",
  },
  {
    id: "6",
    title: "Chương trình Trái tim cho em đến với trẻ em tỉnh Cà Mau",
    description: "Trong ngày 18 và 19/11, chương trình Trái tim cho em có",
    image: ImageExample,
    date: "19/11",
  },
  {
    id: "7",
    title: "BCCU TRAO XE ĐẠP CHO HỌC SINH NGHÈO",
    description:
      "Ngày 03/12/2023, CLB doanh nhân đồng hương Bạc Liêu, Cà Mau tại",
    image: ImageExample,
    date: "03/12/2023",
  },
];
const SocialResponsibilitySlice = createSlice({
  name: "socialresponsibility",
  initialState: {
    items: fakeData,
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload);
    },
    removeItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const { addItem, removeItem } = SocialResponsibilitySlice.actions;
export default SocialResponsibilitySlice.reducer;
